import * as tslib_1 from "tslib";
import { Vue, Prop, Component } from 'vue-property-decorator';
let ShareDiv = class ShareDiv extends Vue {
};
tslib_1.__decorate([
    Prop()
], ShareDiv.prototype, "close", void 0);
ShareDiv = tslib_1.__decorate([
    Component({})
], ShareDiv);
export default ShareDiv;
